import { RouteRecordRaw } from "vue-router";

export const commerceRoutes: RouteRecordRaw[] = [
  {
    path: "customers-commerce",
    name: "customers_commerce",
    redirect: { name: "commerce_ecom" },
    meta: {
      title: "Customers & Commerce",
      text: "Customers & commerce",
      description:
        "Track e-commerce activity and revenue across your storefront",
      icon: "shopping-cart",
      added: "2026-05-22",
    },
    component: () =>
      import("@/views/CustomersCommerce/CustomersCommerceBase.vue"),
    children: [
      {
        path: "ecommerce",
        name: "commerce_ecom",
        meta: {
          title: "E-commerce | Customers & Commerce",
          excludeFromNavbar: true,
        },
        component: () => import("@/views/ECommerce/ECommerceReport.vue"),
      },
      {
        path: "stores",
        name: "commerce_stores",
        meta: {
          title: "Stores | Customers & Commerce",
          excludeFromNavbar: true,
          // No requiredFeatureFlag here: the tab is visible to everyone and
          // StoresGate renders the paywall for orgs without the crm flag.
        },
        component: () => import("@/views/CustomersCommerce/StoresGate.vue"),
      },
      {
        path: "stores/:id",
        name: "commerce_store_detail",
        meta: {
          title: "Store details | Customers & Commerce",
          excludeFromNavbar: true,
          requiredFeatureFlag: "crm",
        },
        component: () => import("@/views/CustomersCommerce/StoreDrilldown.vue"),
      },
    ],
  },
];
